import { createContext, useCallback, useContext, useMemo } from 'react'

import { JourneyScope } from '@cash-web/shared-journey-util-main'

import { JourneyParentContext } from './JourneyParentContext'
import { JourneyContextProps, JourneyNavigate } from './types'

const error = () => {
  throw Error('JourneyProvider not found')
}
export const JourneyContext = createContext<JourneyContextProps>({
  navigate: error,
  cancel: error,
  cancelAll: error,
  complete: error,
  isInProgress: () => false,
  hasParentTarget: () => false,
  matches: () => false,
})

export function useJourneyContext() {
  const parent = useContext(JourneyParentContext)
  const result = useContext<JourneyContextProps>(JourneyContext)

  const navigate = useCallback(
    (path, opts) => result.navigate(path, { ...(opts ?? {}), parent }),
    [parent, result]
  ) as JourneyNavigate

  return useMemo(
    () => ({
      ...result,
      navigate,
    }),
    [result, navigate]
  )
}

export function useJourneyScope(): Partial<JourneyScope> {
  const context = useJourneyContext()

  return context.active?.opts?.scope ?? {}
}
